module.exports = __webpack_public_path__ + "static/media/postgres.7209b9dd.png";